var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-item",class:_vm.navItemClasses},[_c('router-link',{attrs:{"data-corner-image":_vm.name,"to":_vm.url}},[_c('img',{staticStyle:{"width":"178px","height":"40px"},attrs:{"src":"assets/images/clr.png"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }